import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OperatorProvider } from '../operator/operator';
import { take, switchMap } from 'rxjs/operators';
import { Operator, PaginatedApi, Conversion, DealStatus } from '../../models/models';
import { UserAuthProvider } from '../../modules/mrk-user-auth/user-auth';

@Injectable()
export class ContractsProvider {
  baseUrl: string;

  constructor(
    public http: HttpClient,
    private user: UserAuthProvider<any>,
    private readonly operatorProvider: OperatorProvider) {

    this.baseUrl = this.user.config.baseURL
  }

  getContracts(isFinalized: boolean = null, dealStatus: DealStatus = null) {
    return this.operatorProvider.currentOperator.pipe(
      take(1),
      switchMap((operator: Operator) => {
        let params: { [param: string]: string } = {}
        params.operator = `${operator.id}`
        if (isFinalized !== null) {
          params.is_finalized = `${isFinalized}`
        }
        if (dealStatus !== null) {
          params.deal_status = `${dealStatus}`
        }

        return this.http.get<PaginatedApi<Conversion>>(this.baseUrl + "api/crm/conversions/", { params: params })
      })
    )
  }

  getNextContracts(url: string) {
    return this.http.get<PaginatedApi<Conversion>>(url)
  }

  setAslost(conversion: number) {
    return this.http.post<Conversion>(`${this.baseUrl}api/crm/conversions/${conversion}/lose/`, {})
  }

}



// WEBPACK FOOTER //
// ./src/providers/api/contracts.provider.ts